module.exports = __webpack_public_path__ + "assets/img/news3.5.98bc0b77.png";